"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _sendToDatadog = require("./sendToDatadog");
Object.keys(_sendToDatadog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sendToDatadog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sendToDatadog[key];
    }
  });
});
var _logAppEntry = require("./logAppEntry");
Object.keys(_logAppEntry).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _logAppEntry[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _logAppEntry[key];
    }
  });
});